/**
 * The message an error body carries. Backends send it flat ({ message }) or
 * nested under error ({ error: { code, message } }, the ErrorResponse of
 * property-title-admin and platform-admin-api); a legacy body sends error as a
 * string.
 *
 * Its own module so stores/auth.ts can import it: api/client.ts imports the
 * auth store, and an auth-store import of client.ts would be a cycle.
 */
export function apiErrorMessage(body: unknown): string | undefined {
  if (!body || typeof body !== 'object') return undefined;
  const { message, error } = body as { message?: unknown; error?: unknown };
  if (typeof message === 'string' && message.length > 0) return message;
  if (error && typeof error === 'object') {
    const nested = (error as { message?: unknown }).message;
    if (typeof nested === 'string' && nested.length > 0) return nested;
  }
  if (typeof error === 'string' && error.length > 0) return error;
  return undefined;
}
